module.exports = __webpack_public_path__ + "img/fish.c3a0c09f.svg";